import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";
import type { ReactNode } from "react";

type ConfirmDeleteDialogProps = {
  title?: string;
  description?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export const ConfirmDeleteDialog = ({
  title,
  description,
  open,
  onOpenChange,
  onConfirm,
}: ConfirmDeleteDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-no-dnd>
        <AlertDialogHeader>
          <AlertDialogTitle>{title || "Confirm Delete"}</AlertDialogTitle>
          <AlertDialogDescription>
            {description || "Are you sure you want to delete this?"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            autoFocus
            data-testid="confirm-delete-dialog-confirm-button"
            className={buttonVariants({ variant: "destructive" })}
            onClick={() => onConfirm()}
          >
            Confirm
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
